exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".user-profile .user-profile-table table{line-height:25px;width:100%;border-collapse:collapse}.user-profile .user-profile-table table td{padding-top:12px;padding-bottom:12px;font-size:15px;border-bottom-width:1px;border-bottom-style:solid}@media screen and (min-width:768px){.user-profile .user-profile-table{margin-bottom:44px}.user-profile .user-profile-table table{width:500px}.user-profile .user-profile-table table tr td:first-child{width:190px}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/css-loader?minimize!/var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/autoprefixer-loader?{browsers:["last 3 versions"],cascade:false}!/var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/stylus-loader??ref--6-3!/var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/site/root/components/user-profile/stylus/_userProfile.styl
// module id = 560
// module chunks = 4